export default __webpack_public_path__ + "static/media/informationtoprepare.77662268.svg";